/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Trigger from 'rc-trigger';
import classNames from 'classnames';
import Placements from './placements';
function Dropdown(props, ref) {
    const { arrow = false, prefixCls = 'rc-dropdown', transitionName, animation, align, placement = 'bottomLeft', placements = Placements, getPopupContainer, showAction, hideAction, overlayClassName, overlayStyle, visible, trigger = ['hover'] } = props, otherProps = __rest(props, ["arrow", "prefixCls", "transitionName", "animation", "align", "placement", "placements", "getPopupContainer", "showAction", "hideAction", "overlayClassName", "overlayStyle", "visible", "trigger"]);
    const [triggerVisible, setTriggerVisible] = React.useState();
    const mergedVisible = 'visible' in props ? visible : triggerVisible;
    const triggerRef = React.useRef(null);
    React.useImperativeHandle(ref, () => triggerRef.current);
    const getOverlayElement = () => {
        const { overlay } = props;
        let overlayElement;
        if (typeof overlay === 'function') {
            overlayElement = overlay();
        }
        else {
            overlayElement = overlay;
        }
        return overlayElement;
    };
    const onClick = e => {
        const { onOverlayClick } = props;
        const overlayProps = getOverlayElement().props;
        setTriggerVisible(false);
        onVisibleChange(false);
        if (onOverlayClick) {
            onOverlayClick(e);
        }
        if (overlayProps.onClick) {
            overlayProps.onClick(e);
        }
    };
    const onVisibleChange = (visible) => {
        const { onVisibleChange } = props;
        setTriggerVisible(visible);
        if (typeof onVisibleChange === 'function') {
            onVisibleChange(visible);
        }
    };
    const getMenuElement = () => {
        const overlayElement = getOverlayElement();
        const extraOverlayProps = {
            prefixCls: `${prefixCls}-menu`,
            onClick
        };
        if (typeof overlayElement.type === 'string') {
            delete extraOverlayProps.prefixCls;
        }
        return (<>
                {arrow && <div className={`${prefixCls}-arrow`}/>}
                {React.cloneElement(overlayElement, extraOverlayProps)}
            </>);
    };
    const getMenuElementOrLambda = () => {
        const { overlay } = props;
        if (typeof overlay === 'function') {
            return getMenuElement;
        }
        return getMenuElement();
    };
    const getMinOverlayWidthMatchTrigger = () => {
        const { minOverlayWidthMatchTrigger, alignPoint } = props;
        if ('minOverlayWidthMatchTrigger' in props) {
            return minOverlayWidthMatchTrigger;
        }
        return !alignPoint;
    };
    const getOpenClassName = () => {
        const { openClassName } = props;
        if (openClassName !== undefined) {
            return openClassName;
        }
        return `${prefixCls}-open`;
    };
    const renderChildren = () => {
        const { children } = props;
        const childrenProps = children.props ? children.props : {};
        const childClassName = classNames(childrenProps.className, getOpenClassName());
        return triggerVisible && children
            ? React.cloneElement(children, {
                className: childClassName,
            })
            : children;
    };
    let triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
        triggerHideAction = ['click'];
    }
    return (<Trigger {...otherProps} prefixCls={prefixCls} ref={triggerRef} popupClassName={classNames(overlayClassName, {
            [`${prefixCls}-show-arrow`]: arrow
        })} popupStyle={overlayStyle} builtinPlacements={placements} action={trigger} showAction={showAction} hideAction={triggerHideAction || []} popupPlacement={placement} popupAlign={align} popupTransitionName={transitionName} popupAnimation={animation} popupVisible={mergedVisible} stretch={getMinOverlayWidthMatchTrigger() ? 'minWidth' : ''} popup={getMenuElementOrLambda()} onPopupVisibleChange={onVisibleChange} getPopupContainer={getPopupContainer}>
            {renderChildren()}
        </Trigger>);
}
export default React.forwardRef(Dropdown);
